export default () => {
    const input = document.querySelector<HTMLInputElement>('.quantity  > input.qty')
    const rules = document.querySelectorAll('.dynamic-pricing__item')

    if(!rules && !input) {
        return
    }

    rules.forEach((rule) => {
        rule.addEventListener('click', () => {
            input.value = rule.getAttribute('data-quantity')
        })
    })
}